import { Panel, PanelType } from "@fluentui/react";
import themeBase from "../../../../utils/theme/themeBase";
import BaseTelelirk, {
  ETelerikViewmode,
} from "../../../../components/generic/baseTelerik";
import { useCallback } from "react";
import { PanelHeader } from "../../../../components/Panel/PanelHeader";
interface IPanelViewPdfPorChekList {
  isOpen: boolean;
  onDismiss: () => void;
  info?: any;
}
export const PanelViewPdfPorChekList = (props: IPanelViewPdfPorChekList) => {
  const onRenderHeaderPanel = useCallback(
    () => (
      <>
        <PanelHeader
          key={"agregar"}
          nameIconHeader=""
          subTextHeader={`CheckList Registrado por ${props?.info.nombre}`}
          textHeader="Reporte Histórico"
        />
      </>
    ),
    []
  );
  return (
    <div>
      <Panel
        isOpen={props.isOpen}
        onDismiss={props.onDismiss}
        isFooterAtBottom={true}
        onRenderHeader={onRenderHeaderPanel}
        closeButtonAriaLabel="Close"
        type={PanelType.large}
        isLightDismiss
      >
        <div style={themeBase._padding20}>
          <BaseTelelirk
            viewMode={ETelerikViewmode.PRINT_PREVIEW}
            reportName="ListaVerificacion.trdx"
            parametros={{
              listaVerificacionId: props?.info.checkListId,
            }}
          />
        </div>
      </Panel>
    </div>
  );
};
